import React from 'react';

const SkillSessionCompo = () => {
    return (
        <div className='mx-auto'>
            <h1 className='text-md my-5'>Quick 30-minute session designed for group class members
                especially for patrons who deals with specific skill issue. The
                coach will check and correct form and assign homework where
                necessary. Our coaches do their utmost to look out for every
                member however individual attention is not possible. Thus, skill
                session is the solution.</h1>



            <div className="schedule mb-10 md:flex items-center">
                <div className="schedule_time w-full">

                    <h1 className='font-semibold mt-2'>Notes: No package offering. Per Class Only</h1>
                </div>
            </div>

        </div>
    );
};

export default SkillSessionCompo;